<!--
 * @Author: your name
 * @Date: 2021-09-23 10:39:16
 * @LastEditTime: 2021-09-23 15:44:21
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \epec-ea\src\modules\projectA\components\category\companyCategoryDialog.vue
-->
<template>
  <el-dialog
    :append-to-body="true"
    title="选择类目"
    :visible.sync="categoryVisible"
    width="800px"
    :before-close="categoryCancellHandle">
   <el-form :model="formData" ref="formData" label-width="150px" class="demo-formData">
    <el-form-item  label="品牌商城产品目录" prop="categoryIds">
          <el-select  style="width:100%" v-model="formData.categoryIds" multiple placeholder="请选择产品目录">
              <el-option
                  v-for="item in categoryList"
                  :key="item.categoryId"
                  :label="item.categoryName"
                  :value="item.categoryId">
              </el-option>
          </el-select>
      </el-form-item> 

   </el-form>
   <div slot="footer" class="dialog-footer flex-c">
    <el-button @click="categoryCancellHandle()">取 消</el-button>
    <el-button type="primary" @click="submitForm()">确 定</el-button>
  </div>
  </el-dialog>
</template>

<script>
import api from "../../api/product/index";
export default {
  props: {
    categoryVisible: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      treeData:[],
      allCategorList:[],
      categoryList:[],
      formData:{
         categoryIds:[]
      }
     
 
       
    };
  },
  created(){
 
  },
  watch: {
    categoryVisible (newVal) {
      if(newVal){
        //  this.getCategoryList();
         this.init()
      }
     
    },
  },
  methods: {
    init(){
      let BRANDINfO=this.templateInfo=this.$store.state.BRANDINfO
      this.allCategorList=JSON.parse(BRANDINfO.categoryNames) 
      let categoryIds=BRANDINfO.categoryIds.split(',')
      this.formData.categoryIds=[]
      let arr=[];
      this.allCategorList.forEach(item => {
          let name=[]
          if(categoryIds.includes(item.categoryId.toString())){
            item.routeList.forEach(route=>{
              name.push(route.categoryName)
            })
            arr.push({
                categoryId:item.categoryId,
                categoryName:name.join('/')
            })
          }
          
          this.categoryList=arr;
      });
 
    },
    // 类目弹窗取消
    categoryCancellHandle () {
      this.$emit("update:categoryVisible", false);
    },
    //获取搜索列表
    async getCategoryList () {
      let companyId =this.$store.state.USERINFO.companyId;
      let params={
        companyId:companyId
      }
      let res = await api.queryStoreCompanyCategory(params);
      if(res.code==200){

        this.treeData=this.recursionTree(res.data)
      }
  
    },
 

    recursionTree(datas){ //遍历树
      for(let i in datas){
        datas[i].disabled=datas[i].isLeaf==1?false:true
        if(datas[i].children){
          this.recursionTree(datas[i].children);
        }
      }
      return datas
    },

    submitForm(){
 
      let newArr=[]
      this.allCategorList.forEach(item => {
          if(this.formData.categoryIds.includes(item.categoryId)){
              item.routeList.forEach(item1 => {
                if(item1.isLeaf==1){
                  newArr.push(item1)
                }
              });
          }
      });
      this.categoryCancellHandle()
      this.$emit("getCategoryInfo", newArr)
      
    }

     
  },
};
</script>
<style lang="scss" scoped>
 .tree_content{
   min-height: 200px;
   max-height: 460px;
   overflow-y: auto;
 }
</style>
